module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/spqr-rijtjes-onbepaald-voornaamwoord.json
// module id = 1302
// module chunks = 149942498914918